module.exports = __webpack_public_path__ + "img/btn-white-border-cookies.70476cd.svg";